import {UntypedFormControl, ValidationErrors} from '@angular/forms';

export function IncorrectLengthValidator(control: UntypedFormControl): ValidationErrors {
    if (!control.value) {
        return;
    }

    const controlValue = control.value.toString().trim();
    return controlValue.length === 18 || controlValue.length === 22 ? null : {incorrectLength: true};
}
